var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    d: "M29.062 0a.94.94 0 00-.937.938v6.825l-.938.314V.937a.939.939 0 00-1.875 0v7.14l-.937-.314V.938a.939.939 0 00-1.875 0v7.5c0 .403.258.759.641.89l2.171.722v19.012c0 .52.42.938.938.938a.936.936 0 00.937-.938V10.05l2.172-.722a.942.942 0 00.641-.89v-7.5A.939.939 0 0029.062 0zm-5.624 16.406c0-6.46-5.257-11.718-11.72-11.718C5.258 4.688 0 9.947 0 16.405c0 6.464 5.257 11.719 11.719 11.719s11.719-5.255 11.719-11.719zm-21.563 0c0-5.428 4.416-9.843 9.844-9.843 5.428 0 9.844 4.415 9.844 9.843s-4.416 9.844-9.844 9.844c-5.428 0-9.844-4.416-9.844-9.844z"
  })));
}
export default SvgFood1;